// ABOUTME: Exposes the active react-intl instance to code that runs outside the React tree
// ABOUTME: (Apollo links, snackbar helpers), falling back to the default message before mount.

import { IntlShape, MessageDescriptor, useIntl } from 'react-intl';

let intlRef: IntlShape | undefined;

/**
 * Mount once inside the IntlProvider (next to SnackbarUtilsConfigurator): captures the current
 * intl so module-level code can translate with the same locale and messages as the components.
 */
export const GlobalIntlConfigurator = () => {
    intlRef = useIntl();
    return null;
};

/** Translates like `intl.formatMessage`; before the provider mounts it returns the default message. */
export const formatGlobalMessage = (
    descriptor: MessageDescriptor,
    values?: Record<string, string | number>,
): string => {
    if (!intlRef) return String(descriptor.defaultMessage ?? descriptor.id ?? '');
    return intlRef.formatMessage(descriptor, values);
};
